/* eslint-disable @typescript-eslint/no-explicit-any */
import IconArrow from '@assets/icons/big arrow right.svg?react';
import { Box, Typography } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid-pro';
import dayjs from 'dayjs';

import customColors from '../../../utils/customColors';
import { isJson } from '../../../utils/dataTypes';

const CURRENT_TABLE = 'customers';

const badgeStyles = {
 display: 'inline-flex',
 alignItems: 'center',
 justifyContent: 'center',
 color: customColors.darkestGray,
 borderRadius: '15px',
 px: 1,
 py: '4px',
 fontWeight: 500,
};

const colorMap = {
 red: customColors.lightRed,
 green: customColors.lightGreen,
 orange: customColors.lightOrange,
 yellow: customColors.lightYellow,
 blue: customColors.lightBlue,
};

const statusMap = {
 Filled: customColors.lightGreen,
 Partial: customColors.lightYellow,
 'Partial Locked': customColors.lightYellow,
 Aborted: customColors.lightRed,
 Approved: customColors.lightBlue,
};

const xRenderCell = (
 params: GridRenderCellParams,
 name: string,
 type: string,
 customValue: string = '',
) => {
 const value =
  customValue && customValue !== 'undefined' ? customValue : params.value;

 if ((!value && value !== 0) || value === 'null') return '';

 if (params?.rowNode?.type === 'group') {
  return params?.formattedValue ? params.rowNode.groupingKey : value;
 }

 if (name === 'State') {
  return (
   <Typography
    className="limit-span"
    sx={{
     ...badgeStyles,
     backgroundColor: (statusMap as any)?.[value],
    }}
   >
    {value}
   </Typography>
  );
 }
 if (name === 'Cargo') {
  return (
   <Box
    sx={{
     display: 'inline-flex',
     alignItems: 'center',
     justifyContent: 'center',
     borderRadius: '50%',
     background: customColors.lightBlue,
     width: '24px',
     height: '24px',
    }}
   >
    <IconArrow
     title={value}
     style={{
      transform: value === 'In' ? 'rotate(180deg)' : '',
     }}
    />
   </Box>
  );
 }
 if (type === 'boolean') {
  return value ? '+' : '-';
 }
 if (['int32', 'int16', 'double', 'decimal'].includes(type)) {
  // LIMITS

  const lsValue = localStorage.getItem(
   `${import.meta.env.VITE_APP_NAME}_${CURRENT_TABLE}`,
  );

  const tempState = isJson(lsValue || '')
   ? JSON.parse(lsValue || '{}').columns
   : [];
  const thisLimits = tempState?.limit?.[params.field] || [];
  let lastLimitIndex = -1;
  if (thisLimits.length) {
   thisLimits.forEach((item: any) => {
    if (item.limit === '<') {
     if (value < item.value) {
      lastLimitIndex = thisLimits.indexOf(item);
     }
    } else if (item.limit === '>') {
     if (value > item.value) {
      lastLimitIndex = thisLimits.indexOf(item);
     }
    }
   });
  }

  const selectedValue = value || params.value;
  const parts = selectedValue.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  const formattedValue = parts.join('.');

  const hasLimit = lastLimitIndex !== -1;

  // && name !== 'Neto'  ???
  return !hasLimit ? (
   formattedValue
  ) : (
   <Typography
    className="limit-span"
    sx={{
     ...badgeStyles,
     backgroundColor: (colorMap as any)?.[
      hasLimit ? thisLimits[lastLimitIndex].color : 'blue'
     ],
    }}
   >
    {formattedValue}
   </Typography>
  );
 }
 if (type === 'datetime') {
  return dayjs(value).format('YYYY-MM-DD HH:mm:ss');
 }

 if (type === 'array' || typeof value === 'object') {
  return <Typography sx={{ fontSize: 9 }}>{JSON.stringify(value)}</Typography>;
 }
 return value;
};

export default xRenderCell;
